{
  "name": "apply-me",
  "version": "3.6.0",
  "packageManager": "pnpm@9.15.9",
  "scripts": {
    "ng": "nx",
    "generate-env": "tsx scripts/generate-env.ts",
    "prestart": "pnpm generate-env",
    "prebuild": "pnpm generate-env",
    "start": "nx serve",
    "build": "nx build --configuration=production",
    "reset": "nx reset",
    "test": "nx test",
    "generate-icons": "svg-to-ts",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org neosperience-se --project applyme-frontend ./dist/apps/shell && sentry-cli sourcemaps upload --org neosperience-se --project applyme-frontend ./dist/apps/shell"
  },
  "engines": {
    "node": ">=18",
    "pnpm": ">=9"
  },
  "svg-to-ts": {
    "conversionType": "constants",
    "srcFiles": [
      "./libs/ui/icons/src/assets/titles/*.svg",
      "./libs/ui/icons/src/assets/info/*.svg",
      "./libs/ui/icons/src/assets/actions/base/*.svg",
      "./libs/ui/icons/src/assets/actions/active/*.svg",
      "./libs/ui/icons/src/assets/others/*.svg"
    ],
    "outputDirectory": "./libs/ui/icons/src/lib/",
    "fileName": "apm-icons",
    "prefix": "apm",
    "generateType": true,
    "typeName": "ApmIcons",
    "interfaceName": "ApmIcon",
    "svgoConfig": {
      "plugins": [
        "removeDimensions"
      ]
    }
  },
  "private": true,
  "dependencies": {
    "@amcharts/amcharts5": "^5.14.2",
    "@angular-architects/ngrx-toolkit": "^20.5.0",
    "@angular-ru/cdk": "^19.0.0",
    "@angular-ru/ngxs": "^19.0.0",
    "@angular/animations": "~20.3.3",
    "@angular/cdk": "~20.2.8",
    "@angular/common": "~20.3.3",
    "@angular/compiler": "~20.3.3",
    "@angular/core": "~20.3.3",
    "@angular/forms": "~20.3.3",
    "@angular/material": "~20.2.8",
    "@angular/material-date-fns-adapter": "~20.2.8",
    "@angular/material-moment-adapter": "~20.2.8",
    "@angular/platform-browser": "~20.3.3",
    "@angular/platform-browser-dynamic": "~20.3.3",
    "@angular/router": "~20.3.3",
    "@ckeditor/ckeditor5-angular": "^7.0.1",
    "@ckeditor/ckeditor5-build-classic": "^41.4.2",
    "@ckeditor/ckeditor5-core": "^41.4.2",
    "@ckeditor/ckeditor5-engine": "^41.4.2",
    "@ckeditor/ckeditor5-utils": "^41.4.2",
    "@ckeditor/ckeditor5-watchdog": "^41.4.2",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@ng-select/ng-select": "^20.7.0",
    "@ngneat/svg-icon": "^8.0.0",
    "@ngrx/component": "^20.0.1",
    "@ngrx/component-store": "^20.0.1",
    "@ngrx/operators": "^20.0.1",
    "@ngrx/signals": "^20.0.1",
    "@ngx-formly/core": "^7.0.0",
    "@ngxs-labs/actions-executing": "^20.0.0",
    "@ngxs-labs/dispatch-decorator": "^5.0.0",
    "@ngxs/router-plugin": "^20.1.0",
    "@ngxs/storage-plugin": "^20.1.0",
    "@ngxs/store": "^20.1.0",
    "@nx/angular": "21.6.3",
    "@nx/devkit": "21.6.3",
    "@sentry/angular": "^10.27.0",
    "@sentry/cli": "^2.58.2",
    "@stomp/rx-stomp": "^2.2.0",
    "@tanstack/angular-query-experimental": "^5.90.15",
    "ag-grid-angular": "31.0.2",
    "ag-grid-community": "31.0.2",
    "ag-grid-enterprise": "31.0.2",
    "bootstrap": "^5.2.0",
    "fast-deep-equal": "^3.1.3",
    "fast-json-patch": "^3.1.1",
    "file-saver-es": "^2.0.5",
    "immer": "^10.1.3",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^26.2.0",
    "lodash-es": "^4.17.21",
    "marked": "^16.4.0",
    "moment": "^2.30.1",
    "ng-click-outside2": "^18.0.1",
    "ng-lazyload-image": "^9.1.3",
    "ngx-currency": "^19.0.0",
    "ngx-infinite-scroll": "^20.0.0",
    "ngx-markdown": "^20.1.0",
    "ngx-mask": "^20.0.3",
    "ngx-mat-timepicker": "^20.0.1",
    "ngx-skeleton-loader": "^11.3.0",
    "ngx-sonner": "^3.1.0",
    "ngx-spinner": "^19.0.0",
    "ngxs-reset-plugin": "^4.0.0",
    "ngxtension": "^7.0.2",
    "rxjs": "~7.8.0",
    "subsink": "^1.0.2",
    "svg-to-ts": "^7.1.1",
    "swiper": "^12.0.3",
    "text-overflow-clamp": "^1.0.0",
    "ts-cacheable": "^1.0.19",
    "tslib": "^2.3.0",
    "uuid": "11",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~20.3.4",
    "@angular-devkit/core": "~20.3.4",
    "@angular-devkit/schematics": "~20.3.4",
    "@angular-eslint/eslint-plugin": "~20.3.0",
    "@angular-eslint/eslint-plugin-template": "~20.3.0",
    "@angular-eslint/template-parser": "~20.3.0",
    "@angular/cli": "~20.3.0",
    "@angular/compiler-cli": "~20.3.3",
    "@angular/language-service": "~20.3.3",
    "@babel/plugin-proposal-decorators": "^7.16.4",
    "@ngneat/svg-generator": "^7.0.3",
    "@ngxs/devtools-plugin": "^20.1.0",
    "@ngxs/schematics": "^0.0.1-alpha.5",
    "@nx/eslint": "21.6.3",
    "@nx/eslint-plugin": "21.6.3",
    "@nx/jest": "21.6.3",
    "@nx/js": "21.6.3",
    "@nx/plugin": "21.6.3",
    "@nx/workspace": "21.6.3",
    "@schematics/angular": "20.3.4",
    "@swc-node/register": "1.9.2",
    "@swc/cli": "~0.6.0",
    "@swc/core": "~1.13.5",
    "@swc/helpers": "~0.5.12",
    "@trivago/prettier-plugin-sort-imports": "^6.0.0",
    "@types/file-saver-es": "^2.0.3",
    "@types/jest": "29.5.12",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.12.0",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.46.0",
    "@typescript-eslint/parser": "^8.46.0",
    "@typescript-eslint/utils": "^8.46.0",
    "angular-eslint": "^20.3.0",
    "babel-loader": "^8.2.3",
    "css-loader": "^6.5.1",
    "dotenv": "^16.4.7",
    "eslint": "^9.27.0",
    "eslint-config-prettier": "^10.1.5",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-preset-angular": "~14.6.1",
    "jest-util": "^29.7.0",
    "nx": "21.6.3",
    "prettier": "^3.6.2",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "sass": "^1.43.4",
    "sass-loader": "^12.3.0",
    "style-loader": "^3.3.1",
    "ts-jest": "29.4.4",
    "ts-node": "10.9.1",
    "tsconfig-paths-webpack-plugin": "3.5.2",
    "tsx": "^4.21.0",
    "typescript": "~5.9.3",
    "webpack": "^5.63.0"
  }
}
